import Button, { EButtonSize, EButtonType } from "../Buttons/Button";
import "./AccessDeniedScreen.scss";
import React, { FC } from "react";

interface IAccessDeniedScreenProps {}

const AccessDeniedScreen: FC<IAccessDeniedScreenProps> = () => {
  const goBack = () => {
    window.history.back();
  }

  return (
    <div className="access-denied-container">
      <div className="container-content">
        <h1>Access Denied</h1>
        <p>You are not authorized to view this page.</p>
        <Button text="Go back" buttonType={EButtonType.SECONDARY} size={EButtonSize.NORMAL} onClick={goBack} />
      </div>
    </div>
  );
}

export default AccessDeniedScreen;